import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import LabelGenExternalParcelTrackingContainer from '../../../components/componentsLabelGeneration/LabelGenExternalParcelTracking/LabelGenExternalParcelTrackingContainer';

class labelGenExternalParcelTrackingView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <LabelGenExternalParcelTrackingContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default labelGenExternalParcelTrackingView;
